import { createContext, ReactNode, useContext, useState } from "react";


type CustomerAccountUpdateValues = {
  accountNumber: string;
  accountName: string;
  accountGroupType: string;
  parcelNumberFormat: string;
  firstName: string;
  lastName: string;
  companyName: string;
}

type CustomerAccountContextType = {
  handleUpdateValues: (values: { accountNumber: string, accountName: string, firstName: string, lastName: string, companyName: string, accountGroupType: string }) => void;
  handleMoveToStep: (stepNumber: number) => void;
  reset: () => void;
  updateParcelNumberFormat: (format: string) => void;
  currentId: number;
} & CustomerAccountUpdateValues

export const CustomerAccountContext = createContext<CustomerAccountContextType | undefined>(undefined);

function CustomerAccountContextProvider({ children }: { children: ReactNode }) {
  const [currentId, setCurrentId] = useState(1);
  const [accountNumber, setAccountNumber] = useState('');
  const [accountName, setAccountName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [accountGroupType, setAccountGroupType] = useState('');
  const [parcelNumberFormat, setParcelNumberFormat] = useState('');

  const handleUpdateValues = ({ accountNumber, accountName, firstName, lastName, companyName, accountGroupType }: { accountNumber: string, accountName: string, firstName: string, lastName: string, companyName: string, accountGroupType: string }) => {
    setAccountNumber(accountNumber);
    setAccountName(accountName);
    setAccountGroupType(accountGroupType);
    setFirstName(firstName);
    setLastName(lastName);
    setCompanyName(companyName);
  }

  const handleMoveToStep = (stepNumber: number = 1) => {
    setCurrentId(stepNumber)
  }

  const reset = () => {
    setAccountNumber('');
    setAccountName('');
    setAccountGroupType('');
    setCurrentId(1);
  }

  const updateParcelNumberFormat = (format: string) => {
    setParcelNumberFormat(format)
  }


  return (
    <CustomerAccountContext.Provider value={{ accountNumber, handleUpdateValues, accountName, currentId, handleMoveToStep, accountGroupType, reset, updateParcelNumberFormat, parcelNumberFormat, firstName, lastName, companyName }}>
      {children}
    </CustomerAccountContext.Provider>
  );
}

function useCustomerAccount() {
  const context = useContext(CustomerAccountContext);
  if (context === undefined)
    throw new Error("CustomerAccountContext was used outside of CustomerAccountContextProvider");
  return context;
}

export { CustomerAccountContextProvider, useCustomerAccount };